import { render, staticRenderFns } from "./NavigationDrawerNavItem.vue?vue&type=template&id=63ed97f8&scoped=true"
import script from "./NavigationDrawerNavItem.vue?vue&type=script&lang=js"
export * from "./NavigationDrawerNavItem.vue?vue&type=script&lang=js"
import style0 from "./NavigationDrawerNavItem.vue?vue&type=style&index=0&id=63ed97f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ed97f8",
  null
  
)

export default component.exports